import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./PrivacyPolicy.css";
import Footer from "../../Home_Page_WLog/Footer/Footer";
import LoginHeader from "../../Home_Page_WLog/LoginHeader/LoginHeader";
import {
  ShieldCheck,
  Lock,
  Database,
  UserCheck,
  MessageCircle,
  CreditCard,
  Cookie,
  Settings,
  Share2,
  Shield,
  Link2,
  Users,
  AlertTriangle,
  RefreshCcw,
  Mail,
  CheckCircle2,
} from "lucide-react";

const Privacy_Policy = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const privacyPoints = [
    {
      number: "01",
      icon: <ShieldCheck size={20} />,
      title: "Introduction",
      text: "Community Rishtey values your trust. This Privacy Policy explains how we collect, use, and safeguard your information to ensure a safe and secure matrimonial experience.",
    },
    {
      number: "02",
      icon: <Database size={20} />,
      title: "Information We Collect",
      text: "We collect personal details such as your name, age, gender, religion, contact details, and preferences to create your matrimonial profile.",
    },
    {
      number: "03",
      icon: <UserCheck size={20} />,
      title: "Profile Information",
      text: "Details shared by you in your profile will be visible to registered members only, ensuring privacy and controlled access.",
    },
    {
      number: "04",
      icon: <MessageCircle size={20} />,
      title: "Communication Data",
      text: "We may record chats, messages, and emails exchanged on our platform to maintain quality and prevent misuse.",
    },
    {
      number: "05",
      icon: <CreditCard size={20} />,
      title: "Financial Information",
      text: "Payments made for premium services are securely processed through our official gateway. We never store your bank details or OTP.",
    },
    {
      number: "06",
      icon: <Cookie size={20} />,
      title: "Cookies & Tracking",
      text: "Our website uses cookies to improve user experience, analyze traffic, and personalize content without compromising your privacy.",
    },
    {
      number: "07",
      icon: <Settings size={20} />,
      title: "How We Use Your Information",
      text: "Your data is used strictly for matchmaking purposes, account management, and to enhance platform security.",
    },
    {
      number: "08",
      icon: <Share2 size={20} />,
      title: "Sharing of Information",
      text: "We do not sell or rent your personal information. Data is shared only with trusted partners for verification or as required by law.",
    },
    {
      number: "09",
      icon: <Lock size={20} />,
      title: "Data Security",
      text: "We implement strong encryption, firewalls, and access controls to protect your personal and financial information.",
    },
    {
      number: "10",
      icon: <Settings size={20} />,
      title: "User Control",
      text: "You can update, edit, or delete your profile information at any time through your account settings.",
    },
    {
      number: "11",
      icon: <Link2 size={20} />,
      title: "Third-Party Links",
      text: "Our platform may contain links to third-party sites. We are not responsible for their privacy practices, so please review their policies before sharing information.",
    },
    {
      number: "12",
      icon: <Users size={20} />,
      title: "Protection of Minors",
      text: "Community Rishtey is strictly for adults (18+). We do not knowingly collect information from minors.",
    },
    {
      number: "13",
      icon: <AlertTriangle size={20} />,
      title: "Fraud Prevention",
      text: "We actively monitor fraudulent activities and encourage users to report suspicious behavior to keep the community safe.",
    },
    {
      number: "14",
      icon: <RefreshCcw size={20} />,
      title: "Policy Updates",
      text: "This Privacy Policy may be updated periodically. We recommend reviewing it regularly to stay informed about changes.",
    },
    {
      number: "15",
      icon: <Mail size={20} />,
      title: "Contact Us",
      text: "If you have any questions regarding this Privacy Policy, please contact our support team at support@communityrishtey.com.",
    },
  ];

  return (
    <>
      <LoginHeader />

      <div className="privacy-page">
        {/* Hero Section */}
        <section className="privacy-hero">
          <div className="privacy-hero-overlay"></div>

          <div className="privacy-float-wrap">
            {["🔒", "💖", "🛡️", "📜", "✨", "💍", "❤️", "🔐"].map((item, index) => (
              <span key={index} className={`privacy-float privacy-float-${index}`}>
                {item}
              </span>
            ))}
          </div>

          <div className="privacy-hero-content" data-aos="fade-up">
            <div className="privacy-badge">
              <ShieldCheck size={15} />
              Privacy & Protection
            </div>

            <h1 className="privacy-main-title">
              Privacy <span>Policy</span>
            </h1>

            <p className="privacy-subtitle">
              Your trust matters to us. We are committed to protecting your
              personal information with transparency, care, and the highest
              level of security.
            </p>

            <div className="privacy-top-pills">
              <span>🔒 Secure Data</span>
              <span>✅ Trusted Platform</span>
              <span>🛡️ Privacy First</span>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="privacy-container">
          <div className="privacy-header" data-aos="fade-up">
            <span className="privacy-section-badge">Community Rishtey Policy</span>
            <h2 className="privacy-title">How We Protect Your Information</h2>
            <p className="privacy-description">
              We believe privacy is the foundation of trust. These principles explain
              how your information is handled, secured, and used responsibly on our platform.
            </p>
          </div>

          <div className="privacy-grid">
            {privacyPoints.map((item, index) => (
              <div
                key={index}
                className="privacy-card"
                data-aos="zoom-in-up"
                data-aos-delay={index * 60}
              >
                <div className="privacy-card-glow"></div>

                <div className="privacy-card-top">
                  <div className="privacy-icon-wrap">{item.icon}</div>
                  <div className="privacy-number">{item.number}</div>
                </div>

                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>

          <div className="privacy-final-note" data-aos="fade-up">
            <div className="privacy-final-icon">
              <CheckCircle2 size={22} />
            </div>
            <div>
              <h4>Privacy You Can Trust</h4>
              <p>
                By using Community Rishtey, you agree to our Privacy Policy and
                trust us to protect your personal information with the highest
                level of security.
              </p>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default Privacy_Policy;